module.exports = __webpack_public_path__ + "static/case_03-e1cc4e13e911a1bef7b99a62468450b0.jpg";